// src/pages/Portfolio.js
import React from "react";

function Portfolio() {
  return (
    <div>
      <h1>Our Portfolio</h1>
      {/* Add your portfolio content here */}
    </div>
  );
}

export default Portfolio;
